import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario3 from "./Scenario3";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";
import { alertController } from "@ionic/core";
import { endianness } from "os";

export default class Scenario3Part3 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 2;
	private calledSpouse : boolean;

	chapterIds = {
		scenario3_3a_s9: 'CALM - Scenario 3 Start - 3A - Segment 9',
		scenario3_3a_s10: 'CALM - Scenario 3 - 3A - Segment 10',
		scenario3_3a_s10a: 'CALM - Scenario 3 - 3A - Segment 10a', // alternate location of "sounds good, thank you"
		scenario3_3a_s11: 'CALM - Scenario 3 End - 3A - Segment 11',
	}

	constructor(scenario: Scenario3, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario3/calm-scenario3-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario3.parts.level3Part3.id;
	}

	public start() {
		const context = this;
		this.calledSpouse = false;
		context.segment1Step2Dialogue();
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();		
		var spouseResponse = "Call her husband. He can provide informal interpreter services over the phone."
		this.scenario.dialog(
			'CN-C06-L2-000b',
			[{
				text: 'We are going to have to delay the surgery until the morning. We do not have any access to interpreters during night shifts.',
				feedback: 'This is an emergent appendectomy. This procedure needs to happen tonight. Delaying surgery is not an option.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: spouseResponse,
				scoreType: ScoreType.Ok,
				isCorrect: false // Rank okay				
			}, {
				text: 'Just have Mrs. Srisati sign the form. We will brief her after the procedure, in the morning.',
				feedback: 'You can’t force a patient to sign a consent form. It’s unethical. Furthermore, this patient needs to be briefed about the surgery and associated risks, regardless of how safe it may be. This patient needs to have interpreter services.',
				scoreType: ScoreType.Worst2,
				isCorrect: false // rank offense (point worth -500)
			}, {
				text: 'I need to look up our facility’s policies for interpreter services before proceeding.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				this.scenario.gameManager.UiManager.hideAllUis([]);
				context.scenario.updateObjective('');
				if (selectedOption.text.indexOf(spouseResponse) !== -1) {			
					context.segment2Step1CallSpouseResponse();
				}
				else {
					if(this.calledSpouse) {
						context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1aCalledSpouseThenGoToPC(), context.partIndx);	
					} else {
						context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1GoToPC(), context.partIndx);
					}
					
				}
			}
		);
		this.scenario.updateObjective('Select your response to Heather')
	}

	private segment2Step1CallSpouseResponse() {
		
		this.calledSpouse = true;
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario3_3a_s9, () => {
			context.scenario.updateObjective('');
			this.scenario.gameManager.UiManager.showAllUis([]);
		});
	}

	private segment3Step1aCalledSpouseThenGoToPC() {
		//this.scenario.gameManager.UiManager.hideAllUis([]);
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.updateObjective('Use Nurse Station Computer to look up Interpreter Services Policies');
		context.playVideoChapter(context.chapterIds.scenario3_3a_s10a, () => {
			context.segment3Step2UsePC();
		});
	}

	private segment3Step1GoToPC() {
		//this.scenario.gameManager.UiManager.hideAllUis([]);
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.updateObjective('Use Nurse Station Computer to look up Interpreter Services Policies');
		context.playVideoChapter(context.chapterIds.scenario3_3a_s10, () => {
			context.segment3Step2UsePC();
		});
	}

	private segment3Step2UsePC() { // This interaction is just a scrollable text field with text		
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: {
				text:
					` 
					<p class="regular-description-font" style="margin: 0">
					LIMITED ENGLISH PROFICIENCY SERVICES<br /><br >
					<span style="color: rgb(222, 225, 156)">
					1. PURPOSE. To implement a Limited English Proficiency (LEP) program for telephonic language interpretation and on-site language interpretation at the VAMC, and establish the policy and responsibilities associated with this program. <br /><br />

					2. POLICY. It is the policy of this medical center that all Veterans receive equitable and the highest quality of health care obtainable. To this end, those Veterans with limited English proficiency shall not receive lesser healthcare resulting from a failure to effectively communicate VHA health care treatment options and benefits. <br /><br />

					3. ACTIONS/PROCEDURES.</span> <br /><br />

						a.Contact Interpreter Services. <br /><br />

						b. Local staff may provide interpretation services to help explain common or daily nursing care instructions. Local staff may not provide interpretation services for official medical forms requiring patient signature. < /br>< /br>

						c. If the need for telephonic interpreter services arises at the medical center, the healthcare provider should: <br /><br />

							1. When feasible and if not already done, bring the patient to a private area with a phone that has speakerphone options, and <br /><br />

							2. Follow the instructions provided in Attachment A.
					</p>
					`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment3Step3Quiz();
			}
		})
	}

	private segment3Step3Quiz() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
			title: 'When can local staff provide interpretation services?',
			options: [
				{
					text: 'Only for common or daily nursing care instructions.',
					isCorrect: true, //Rank Best
					scoreType: ScoreType.Best,
					feedback: 'According to this unit’s policy, local staff are allowed to provide interpretation services for common or daily nursing care instructions but not for official medical forms.',
				},
				{
					text: 'Only for official medical forms.',
					scoreType: ScoreType.Zero,
					isCorrect: false, //Rank Zero
					feedback: 'According to this unit’s policy, local staff are not allowed to provide interpretation services for official medical forms.',
				},
				{
					text: 'For all patient care needs and medical forms.',
					scoreType: ScoreType.Zero,
					isCorrect: false, //Rank Zero
					feedback: 'According to this unit’s policy, local staff are not allowed to provide interpretation services for all patient care needs and medical forms.'
				},
				{
					text: 'Never.',
					scoreType: ScoreType.Zero,
					isCorrect: false, //Rank Zero
					feedback: 'According to this unit’s policy, local staff are allowed to provide some interpretation services.'
				}
			],
			onChoiceSelected: (selectedOption: DialogueUIOptionConfig) => {
				context.scenario.evaluateAnswer(selectedOption, () => { }, context.partIndx,[constants.uiTags.youRespond])
			},
			onClosed: (config: NurseStationComputerSingleQustionUIConfig) => {
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment4Step1ReturnToHeather();
			},
		})
	}

	private segment4Step1ReturnToHeather() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Give Heather the Language Policy Instructions');
		context.playVideoChapter(context.chapterIds.scenario3_3a_s11, () => {
			context.onDone();
		});
	}
}